import { useEffect, useState } from "react";

export default function IdData({features, params}){
    const centerStyle = "center_perfect";
    const [dataId, setDataId] = useState("-")
    const [toggleFullId, setToggleFullId] = useState(false)
    const [generatedId, setGeneratedId] = useState("")

    const generateId = (data = "") => {
        const idLength = data.length
        const arrText = data.split("")
        const newArr = arrText.map((val, index) => {
            if(index < idLength - 5){
                return "*"
            } else {
                return val
            }
        })
        return newArr.join("")
    }
    
    const toggleShowFullId = () => {
        if(toggleFullId){
            setToggleFullId(false)
            const setId = generateId(dataId)
            setGeneratedId(setId)
        } else {
            setToggleFullId(true)
            setGeneratedId(dataId)
        }
    }

    useEffect(() => {
        const key = params?.row?.key
        const fieldKey = params?.field

        // Jika data penting belum tersedia, set ke nilai default
        if(!key || !fieldKey || !features){
            setGeneratedId("-")
            setDataId("-")
        }

        const data = features?.find(item => {
            if(item.key){
                return item.key === key
            } else {
                return item.child_uuid === key
            }
        })
        
        if(!data || !data.properties || data.properties[fieldKey] === null){
            setGeneratedId("-")
            setDataId("-")
            return
        }
        
        const id = data?.properties[fieldKey]
        const setId = generateId(id)
        
        setGeneratedId(setId)
        setDataId(id)
    },[features, params])

    return (
        <>
            <span
                className={`hide-scrollbar ${centerStyle}`}
                style={{ height: "100%", overflowY: "auto", cursor: "pointer" }}
                onMouseEnter={toggleShowFullId}
                onMouseLeave={toggleShowFullId}
            >{generatedId}
            </span>
        </>
    )
}